module.exports = __webpack_public_path__ + "static/media/HN1.4dafca6a.jpg";